import React from 'react';

import Section from '@dashboard/components/sections/Section';
import { usePlatformVerifiedEmailAddressesQuery } from '@dashboard/generated/wp/administrator';
import { useCurrentPage } from '@dashboard/hooks/route/useCurrentPage';
import { Stack, Typography } from '@mui/material';

type Props = {
  platformId: string;
};
export default function VerifiedEmailAddressesSection({ platformId }: Props) {
  const page = useCurrentPage() - 1;
  const { data } = usePlatformVerifiedEmailAddressesQuery({ variables: { platformId, page } });
  const connection = data?.PlatformVerifiedEmailAddresses;

  if (!connection) {
    return null;
  }
  const { count, nodes } = connection;
  return (
    <Section title={<>Verified email addresses ({count})</>} variant="secondary">
      {nodes.map((n, i) => (
        <Stack direction="row" justifyContent="space-between" key={i} paddingY={1}>
          <Typography>{n.value}</Typography>
        </Stack>
      ))}
    </Section>
  );
}
